import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICloseServiceOrder } from '@interfaces/close-service-order.interface';
import { IServiceOrder } from '@interfaces/service-order.interface';
import { Api } from '@root/core/constants/api-routes.constants.';
import { CONFIG } from '@root/core/constants/app.constants';
import { StatusEnums } from '@root/core/enums/status-orden-service.enums';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ServiceOrdersService {
  server = CONFIG.API_SERVER;
  api = Api.SERVICE_ORDERS

  constructor(private httpClient: HttpClient) { }
  getAll(): Observable<IServiceOrder[]> {
    const url = `${this.server}${this.api}`
    return this.httpClient.get<IServiceOrder[]>(url)
  }
  getById(id: number): Observable<IServiceOrder[]> {
    const url = `${id}`
    return this.httpClient.get<IServiceOrder[]>(url)
  }
  create(order: IServiceOrder): Observable<IServiceOrder> {
    const url = `${this.server}${this.api}/`
    return this.httpClient.post<IServiceOrder>(url, order)
  }
  update(order: IServiceOrder): Observable<IServiceOrder> {
    const url = ``
    return this.httpClient.put<IServiceOrder>(url, order)
  }
  delete(id: number): Observable<any> {
    const url = `${id}`
    return this.httpClient.delete<IServiceOrder>(url)
  }
  getAllOrderServiceByTechnical(technicalId: number): Observable<IServiceOrder[]> {
    const url = `${this.server}${this.api}/technical/${technicalId}`
    return this.httpClient.get<IServiceOrder[]>(url)
  }
  getAllOrderServiceByOwner(ownerId: number): Observable<IServiceOrder[]> {
    const url = `${this.server}${this.api}/owner/${ownerId}`
    return this.httpClient.get<IServiceOrder[]>(url)
  }
  getAllOrderServiceByVehicleId(vehicleId: number): Observable<IServiceOrder[]> {
    const url = `${this.server}${this.api}/license-plate/all/${vehicleId}`
    return this.httpClient.get<IServiceOrder[]>(url)
  }
  changeStatus(status: StatusEnums, serviceOrderId: number): Observable<IServiceOrder> {
    const url = `${this.server}${this.api}/change-state/${serviceOrderId}`
    return this.httpClient.patch<IServiceOrder>(url, status)
  }
  closeServiceOrder(data: ICloseServiceOrder, serviceOrderId: number): Observable<IServiceOrder> {
    const url = `${this.server}${this.api}/close-order/${serviceOrderId}`
    return this.httpClient.patch<IServiceOrder>(url, data)
  }
}
